import { TextFileReader } from "@/application/upload/ports/TextFileReader";

export class BrowserTextFileReader implements TextFileReader {
  readContent(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result;
        if (typeof result === "string") {
          resolve(result);
        } else {
          reject(new Error("Failed to read text file content"));
        }
      };

      reader.onerror = () => {
        reject(new Error("Error reading text file"));
      };

      reader.readAsText(file);
    });
  }
}

